export const gameStates = Object.freeze({
    IDLE: "idle",
    ROUND_START: "roundStart",
    ROUND_CONTINUE: "roundContinue",
    ROUND_END: "roundEnd",
    RESULT: "result",
  });